import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../common/Header";
import { connect } from "react-redux";
import alloy from "@alloyidentity/web-sdk";
import VerificationCodeInput from "../common/VerificationCodeInput";
import Logo from "../../assets/tomo_logo_black.svg";
import { track } from "../../api/heap";
import * as actions from "../../state/actions/onboarding";
import faceId from "../../assets/face_id.svg";

const contactUrl = `${process.env.REACT_APP_DOMAIN}/support`;

class VerifyIdDocs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }

  searchParams = () =>
    window.location.search
      .slice(1)
      .split("&")
      .reduce((a, c) => ({ [c.split("=")[0]]: c.split("=")[1], ...a }), {});

  componentDidMount() {
    if (!(this.props.step || {}).stepIsComplete) {
      const params = this.searchParams();
      const token = (this.props.user || {}).entityToken;
      const entityToken = token || params.entity;
      console.log(
        "entity token",
        entityToken ? "obtained successfully" : "not present"
      );
      const {
        user: {
          email,
          firstName: nameFirst,
          lastName: nameLast,
          dob,
          normalizedAddress: {
            address_street: addressLine1,
            address_city: addressCity,
            address_postal_code: addressPostalCode,
            address_subdivision: addressState,
            address_country_code: addressCountryCode
          } = {}
        } = {}
      } = this.props;
      const d = `${dob}`;
      const birthDate = `${d.slice(0,4)}-${d.slice(4,6)}-${d.slice(6,8)}`;
      const alloyInitParams = {
        key: "f47247a5-a181-4e16-ac82-753aba2f7b39",
        entityToken,
        externalEntityId: email,
        production:
          process.env.REACT_APP_NODE_ENV === "production" ? true : false,
        maxEvaluationAttempts: 3,
        documents: ["license", "passport"],
        selfie: false,
        evaluationData: {
          nameFirst,
          nameLast,
          addressLine1,
          // addressLine2,
          addressCity,
          addressState,
          addressPostalCode,
          addressCountryCode,
          birthDate
        },
        validationPreChecks: true
      };
      console.log("Alloy init params:", alloyInitParams);
      alloy.init(alloyInitParams);
      // Second argument is div id/class name, defaults to absolute positioning
    } else {
      console.log("Step is already complete");
    }
  }

  openAlloy = () => {
    alloy.open(this.callback, "idverify");
  };

  componentDidUnmount() {
    window.onpopstate = () => {};
  }

  callback = data => {
    console.log("Alloy container has called callback with data:", data);
    const {
      document_token_front,
      document_token_back,
      evaluation_token,
      entity_token,
      outcome // By default, "Approved", "Manual Review", or "Denied"
    } = data;
    console.log("document_token_front", document_token_front);
    console.log("document_token_back", document_token_back);
    console.log("evaluation_token", evaluation_token);
    console.log("entity_token", entity_token);
    console.log("outcome", outcome);
    const { updateStep, updateUserDatabase, user: { email } = {} } = this.props;
    updateStep("verifyIdDocs", { stepIsComplete: true });
    if (!email) {
      console.log("No user email in verifyIdDocs!");
      this.setState({ error: "Something went wrong saving your progress" });
      return;
    }
    updateUserDatabase(email, {
      applicationProgress: {
        lastCompletedStep: 8,
        documentUpload: true
      }
    });
    alloy.close();
  };

  renderVerifyContainer = () => {
    return (
      <div className="stepContainer">
        <Header />
        <div className="innerStepContainer">
          <div className="outerStack-mobile sm:outerStack">
            <div className="innerStack">
              <div style={{ maxHeight: 220 }}>
                <img
                  alt="ID graphic"
                  src={faceId}
                  className="mx-auto py-6"
                  style={{ maxWidth: 120 }}
                />
              </div>
              <div
                className="stepDescriptionText"
                style={{ padding: 0, margin: 0 }}
              >
                {"Verify Identity"}
              </div>
              <div className="m-auto max-w-xs pt-2">
                <span>
                  Looks like we need additional information to verify your
                  identity. Please use the button below to continue.
                </span>
              </div>
            </div>
          </div>
          <input
            type="button"
            name="button"
            value={"Continue"}
            onClick={this.openAlloy}
            className="continueButton cursor-pointer"
            style={{ margin: 0 }}
          />
          <div id="idverify"></div>
        </div>
      </div>
    );
  };

  renderComplete = () => {
    const done = () => {
      window.localStorage.removeItem("jwt");
      window.location.replace("/");
    };
    return (
      <div className="outerStack-mobile sm:outerStack">
        <div className="innerStack">
          <div className="mx-auto sm:mx-0 mt-12 p-2">
            <img
              alt="Tomo Logo"
              src={Logo}
              className="m-auto"
              style={{ maxWidth: 120 }}
            />
          </div>
          <div style={{ maxHeight: 220 }}>
            <img
              alt="ID graphic"
              src={faceId}
              className="mx-auto py-6"
              style={{ maxWidth: 120 }}
            />
          </div>
          <div className="textContainer" style={{ maxWidth: 240 }}>
            <span className="font-bold text-gray-500">APPLICATION STATUS</span>
          </div>
          <div
            className="stepDescriptionText"
            style={{ padding: 0, margin: 0 }}
          >
            {"Documents in review"}
          </div>
          <div className="m-auto max-w-xs pt-2">
            <span>
              We are reviewing your uploaded documents and will get back to you
              soon with your application results.
            </span>
          </div>
          <input
            type="button"
            name="button"
            value={"Done"}
            onClick={done}
            className="continueButton cursor-pointer"
            style={{ backgroundColor: "black" }}
          />
          <div
            className="textContainer"
            style={{ maxWidth: 300, paddingTop: 12 }}
          >
            <span>Have any questions? </span>
            <a href={contactUrl} style={{ color: "#28EBC1" }}>
              Contact us
            </a>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { step: { stepIsComplete } = {} } = this.props;
    const { renderComplete, renderVerifyContainer } = this;
    return stepIsComplete ? renderComplete() : renderVerifyContainer();
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.verifyIdDocs,
    complete: state.register.applicationProgress.verifyIdDocs
  }),
  actions
)(VerifyIdDocs);
